import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Collapse from 'react-bootstrap/lib/Collapse';
import ItemWrapper from './ItemWrapper';
import Title from './Title';
import CheckboxWithOnly from './CheckboxWithOnly';
import {formatPrice} from 'lib/helpers/globalize-helper';

class Providers extends Component {
  state = {
    show: true
  };

  toggleFilter = () => this.setState((prevState) => ({show: !prevState.show}));

  toggleProvider = (e) => this.props.toggleProvider(e.target.value);

  render() {
    const {show} = this.state;
    const {
      allProvidersAreChecked, providers, selectSingleProvider,
      toggleAllProviders, currency, translations} = this.props;

    const {metaResults: {allProviders, providers: providersTr}} = translations;
    const ALL = 'all';

    return (
      <ItemWrapper>
        <Title
          title={providersTr}
          isOpen={show}
          onClick={this.toggleFilter}
        />
        <Collapse in={show}>
          <div className="filter-content">

            <CheckboxWithOnly
              key={ALL}
              value={ALL}
              isChecked={allProvidersAreChecked}
              label={allProviders}
              onChange={() => toggleAllProviders()}
            />

            {
              providers.options.map(({name, presentationName, price}) => (
                <CheckboxWithOnly
                  key={name}
                  value={name}
                  isChecked={providers.selectedOptions.indexOf(name) !== -1}
                  label={presentationName}
                  price={formatPrice(price, currency)}
                  onChange={this.toggleProvider}
                  onClickOnly={selectSingleProvider}
                  translations={translations}
                />))
            }

          </div>
        </Collapse>
      </ItemWrapper>
    );
  }
}

Providers.propTypes = {
  providers: PropTypes.shape({
    options: PropTypes.object.isRequired,
    selectedOptions: PropTypes.object.isRequired,
    name: PropTypes.string,
    price: PropTypes.number
  }),
  allProvidersAreChecked: PropTypes.bool.isRequired,
  selectSingleProvider: PropTypes.func.isRequired,
  currency: PropTypes.string.isRequired,
  toggleAllProviders: PropTypes.func.isRequired,
  toggleProvider: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    metaResults: PropTypes.string.isRequired,
    priceRange: PropTypes.string.isRequired,
    maxPrice: PropTypes.string.isRequired,
    reset: PropTypes.string.isRequired
  })
};

export default Providers;
